import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import AboutSection from '@/components/AboutSection';
import ReviewsSection from '@/components/ReviewsSection';
import InfoSection from '@/components/InfoSection';
import WhyChooseUs from '@/components/WhyChooseUs';
import Footer from '@/components/Footer';
import Cart from '@/components/Cart';
import { useCart } from '@/context/CartContext';
import PageSEO from '@/components/PageSEO';

const Index = () => {
  const { ordersEnabled } = useCart();
  const location = useLocation();

  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    if (scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(scrollTo);
        if (element) {
          const headerHeight = 80;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: elementPosition - headerHeight, behavior: 'smooth' });
        }
      }, 100);
      // Clean up state
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Pizzeria La Torre Di Latorre Alessandro, Carmagnola (TO)"
        description="Pizzeria da asporto a Carmagnola (TO). Pizza tradizionale e senza glutine certificata AIC. Impasto artigianale, ingredienti selezionati. Ordina e ritira!"
      />
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <InfoSection />
        <WhyChooseUs />
        <ReviewsSection />
      </main>
      <Footer />
      {ordersEnabled && <Cart />}
    </div>
  );
};

export default Index;
